// Per-show switches for work done on the server (Josh, 19-20 Oct 2026: ships dark on staging
// and production). Both are project-doc fields set with the Admin SDK on chosen shows only; no
// UI sets them. Absent or anything but `true` = today's browser path, unchanged.
//
// - serverPageChange: insert / delete / replace renumber the show on the server
//   (functions applyPageChange), with the page-change lock taken at the click.
// - serverVersionSave: History saves and Save & Continue copies are made on the server
//   (functions createVersionSnapshot). A serverPageChange show also saves on the server,
//   as on sandbox: the browser copy is the slow half of Save & Continue.

export function usesServerPageChange(project) {
    return !!project && project.serverPageChange === true;
}

export function usesServerVersionSave(project) {
    return !!project && (project.serverVersionSave === true || project.serverPageChange === true);
}

export default { usesServerPageChange, usesServerVersionSave };


// WEBPACK FOOTER //
// ./src/lib/server-switches.js